import { PermissionToggle } from "@/components/access-control/PermissionToggle";
import { RoleToggle } from "@/components/access-control/RoleToggle";
import { Button } from "@/components/ui/Button";
import type { Permission, UserRole } from "@/contexts/UserContext";
import type { ReactNode } from "react";
import { Outlet, useNavigate } from "react-router-dom";

export function RoleGuard({
  allowedRoles,
  children,
  hideUnauthorizedMessage,
}: {
  readonly allowedRoles: UserRole[];
  readonly children?: ReactNode;
  readonly hideUnauthorizedMessage?: boolean;
}) {
  return (
    <RoleToggle
      allowed={children ?? <Outlet />}
      allowedRoles={allowedRoles}
      denied={hideUnauthorizedMessage === true ? null : <UnauthorizedDisplay />}
      loading={<Outlet />}
    />
  );
}

export function PermissionGuard({
  requiredPermission,
  children,
}: {
  readonly requiredPermission: Permission;
  readonly children?: ReactNode;
}) {
  return (
    <PermissionToggle
      allowed={children ?? <Outlet />}
      denied={<UnauthorizedDisplay />}
      loading={<Outlet />}
      permission={requiredPermission}
    />
  );
}

export function UnauthorizedDisplay({
  details,
}: {
  readonly details?: string;
}) {
  const navigate = useNavigate();
  return (
    <div className="flex size-full flex-col items-center justify-center gap-y-2">
      <p className="text-2xl font-bold">
        Es tut uns leid, aber Sie haben keine Berechtigung, diese Seite zu
        sehen.
      </p>
      {details != null && <p className="text-sm/none">{details}</p>}
      <Button onClick={() => navigate("/")} variant="primary">
        Zurück zur Startseite
      </Button>
    </div>
  );
}
